import { createStyles } from "@mantine/core";
import moment from "moment";

const useStyles = createStyles(() => ({
  card: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    padding: "10px 8px",
    border: "1px solid transparent",
    borderRadius: "6px",
    gap: "2px",
    cursor: "default",
    userSelect: "none",
  },

  slotTitle: {
    margin: 0,
    fontSize: "11px",
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#667085",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    lineHeight: 1.2,
    textAlign: "center",
  },

  activeCard: {
    backgroundColor: "#FAE7BE",
    borderColor: "var(--app-primary)",
  },

  activeSlotTitle: {
    color: "#92400E",
  },
}));

const TodayDateCard = ({ slots }) => {
  const { classes, cx } = useStyles();

  const isCurrentSlot = () => {
    const currentTime = moment();
    const startTime = moment(slots?.startTime, "HH");
    const endTime = moment(slots?.endTime, "HH:mm");
    return currentTime.isBetween(startTime, endTime);
  };

  const active = isCurrentSlot();

  return (
    <div className={cx(classes.card, { [classes.activeCard]: active })}>
      <p
        className={cx(classes.slotTitle, { [classes.activeSlotTitle]: active })}
      >
        {slots?.title}
      </p>
    </div>
  );
};

export default TodayDateCard;
